<template>
  <div id="layout-container" class="d-flex align-items-stretch h-100">
    <sidebar />
    <div
      class="d-flex flex-column flex-grow-1 bg-extra-light-gray"
      style="min-width: 0"
    >
      <topbar />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import Topbar from "./Topbar.vue";
export default {
  components: { Sidebar, Topbar }
};
</script>
